import { useState, useMemo } from 'react';
import { useAppData } from '@/contexts/AppDataContext';

export interface Agent {
  name: string;
  microsoftId: string;
}

interface UseAgentsReturn {
  agents: Agent[];
  loading: boolean;
  error: string | null;
  selectedAgents: string[];
  allAgentIds: string[];
  setSelectedAgents: (agents: string[]) => void;
}

export function useAgents(initialSelectedAgents: string[] = [""]): UseAgentsReturn {
  // TCX-6500: source from the role-aware queues data (uniqueAgents) instead of the legacy,
  // unscoped /agents/status feed — this data is already fetched for the Queue/Direct-Agent-Group
  // filters, so this introduces no additional network request.
  const { uniqueAgents: agents, loaded, errors } = useAppData();
  const loading = !loaded;
  const error = errors.queues;
  const [selectedAgents, setSelectedAgents] = useState<string[]>(initialSelectedAgents);

  const allAgentIds = useMemo(
    () => agents.filter(a => a.microsoftId !== '').map(a => a.microsoftId),
    [agents]
  );

  return { agents, loading, error, selectedAgents, setSelectedAgents, allAgentIds };
}
